import { render, staticRenderFns } from "./data-presentation.vue?vue&type=template&id=02c3053e&scoped=true"
import script from "./data-presentation.vue?vue&type=script&lang=js"
export * from "./data-presentation.vue?vue&type=script&lang=js"
import style0 from "./data-presentation.vue?vue&type=style&index=0&id=02c3053e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c3053e",
  null
  
)

export default component.exports